<template>
  <v-row>
    <v-col :cols="labelWidth" class="no-padding align-vertical">
      <div>{{ label }}:</div>
    </v-col>
    <v-col :cols="inputWidth" class="no-padding align-vertical">
      <UserInput 
        v-if="!staticField"
        :value="inputPayload"
        :options="options"
        :dropdown="dropdown"
        :check-box="checkBox"
        :is-disabled="isDisabled"
        :is-number="isNumber"
        :rules="rules"
        @valueUpdatedEvent="catchVal"
      />
      <div v-else>
        <span>{{ inputPayload }}</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>

import UserInput from './UserInput.vue';

// import { Logger } from "aws-amplify";
// const logger = new Logger("App");

export default {
  name: 'FormRow',
  components: {
    UserInput
  },
  props: {
    label: {
      type: String,
      required: true
    },
    inputPayload: {
      type: [Array, String, Number, Boolean],
      required: true
    },
    staticField: {
      type: Boolean,
      required: false,
      default: () => false
    },
    options: {
      type: Array,
      required: false,
      default: () => []
    },
    dropdown: {
      type: Boolean,
      required: false,
      default: () => false
    },
    checkBox: {
      type: Boolean,
      required: false,
      default: () => false
    },
    isNumber: {
      type: Boolean,
      required: false,
      default: () => false
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    labelWidth: {
      type: Number,
      default: 4,
      required: false
    },
    inputWidth: {
      type: Number,
      default: 8,
      required: false
    }
  },
  methods: {
    catchVal(val) {
      this.$emit('parseNewVAl', val)
    }
  }
}
</script>

<style lang="scss" scoped>
  .no-padding {
    padding: .5em !important;
    margin: 0 !important;
  }
  .align-vertical {
    justify-content: left;
    align-items: center;
    display: flex;
  }
</style>